import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";

import Modal from "UI/Modal";
import Button from 'UI/Button';
import TextArea from "UI/Form/TextArea";

export default class PublishStoryModal extends React.Component
{
    state = {
        busy: false,
    };

    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        story: PropTypes.object.isRequired,
        slug: PropTypes.string.isRequired,
        onPublish: PropTypes.func.isRequired,
        onUnpublish: PropTypes.func.isRequired,
    };

    onPublish = e => {
        e.preventDefault();

        this.setState({busy: true}, () => {
            this.props.onPublish(this.props.story.id).then(() => {
                this.setState({busy: false});
            });
        });
    };

    onUnpublish = e => {
        e.preventDefault();

        this.setState({busy: true}, () => {
            this.props.onUnpublish(this.props.story.id).then(() => {
                this.setState({busy: false});
            });
        });
    };

    render()
    {
        const published = !! this.props.story.published_at;

        const { open, onClose, story } = this.props;

        return <Modal open={open} onClose={onClose} className='max-w-md w-full max-h-full'>
            <Modal.Header>
                Publish Story
            </Modal.Header>
            <Modal.Content className="text-sm text-gray-500">
                <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                    <Column title='Story name'>
                        { story.name }
                    </Column>
                    <Column title='Status'>
                        {
                            published
                                ? <><EyeIcon className='h-4 inline-block align-text-bottom' /> Published</>
                                : <><EyeOffIcon className='h-4 inline-block align-text-bottom' /> Unpublished</>
                        }
                    </Column>

                    {
                        published && <>
                            <Column title='Published by'>
                                You
                            </Column>
                            <Column title='Date published'>
                                { story.published_at }
                            </Column>
                            <Column title='Public URL' span={2}>
                                <a href={story.public_url} target='_blank' className='text-blue-500'>
                                    {story.public_url}
                                </a>
                            </Column>
                            {
                                this.renderEmbedScript()
                            }
                        </>
                    }
                </dl>
            </Modal.Content>
            <Modal.Footer>
                {
                    ! published && <Button type='primary' onClick={this.onPublish} busy={this.state.busy}>Publish</Button>
                }

                <Button onClick={onClose}>Close</Button>

                <div className='flex-grow' />

                {
                    published && <Button type='danger' onClick={this.onUnpublish} busy={this.state.busy}>Unpublish</Button>
                }
            </Modal.Footer>
        </Modal>;
    }

    renderEmbedScript()
    {
        if (! this.props.story) {
            return null;
        }

        if (! this.props.story.public_url) {
            console.log(this.props.story);

            return null;
        }

        const dataUrl = this.props.story.public_url
            .replace('.html', '')
            .replace('https://', 'https://cdn.');

        const code = `<div class='pw-story' data-url='${dataUrl}/story.json'></div>
<script crossorigin src='https://player.trypatchwork.com/player.min.js'></script>`;

        return <Column title='Embed code' span={2}>
            <TextArea
                id='embed-code'
                value={code}
                readOnly
                onFocus={e => e.target.select()}
                onClick={e => e.target.select()}
                className='whitespace-pre whitespace-nowrap scrolling-auto'
                rows={2}
                autosize={false}
            />
        </Column>;
    }

    renderUnpublishedContent()
    {
        return <p>
            <span>
                <EyeOffSolid className='w-6 align-middle' />
                Status:
            </span>
            <span>
                is not currently published.
            </span>
        </p>;
    }

    renderPublishedContent()
    {
        return <p>
            <span>
                <EyeSolid className='w-6 align-middle' />
                Status:
            </span>
            <span>
                last published on: { this.props.story.published_at }
            </span>
        </p>;
    }
}

const Column = ({title, span = 1, children}) => {

    const classes = classNames({
        'sm:col-span-1': span === 1,
        'sm:col-span-2': span === 2,
    });

    return <div className={classes}>
        <dt className="text-sm font-medium text-gray-500">
            { title }
        </dt>
        <dd className="mt-1 text-sm text-gray-900">
            { children }
        </dd>
    </div>;
}